import { render, staticRenderFns } from "./OrganizationUserProfile.vue?vue&type=template&id=5dd2701e&scoped=true&"
import script from "./OrganizationUserProfile.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUserProfile.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationUserProfile.vue?vue&type=style&index=0&id=5dd2701e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd2701e",
  null
  
)

export default component.exports